import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './DashboardIcons';
import { SectionCard, EmptyState } from './TodaySchedule';

// تنبيهات مستنتجة من البيانات الحقيقية فقط — لا تنبيهات مخترعة
const RESULT_NOT_REQUIRED = ['cancelled', 'canceled', 'postponed'];

export const buildAttentionItems = ({ matches }) => {
  const items = [];
  const now = new Date();

  // المباراة متأخرة فقط إذا: موعدها مضى فعلياً + حالتها تتطلب نتيجة + لا نتيجة مسجلة
  const overdue = (matches || []).filter((m) => {
    const d = new Date(m.match_date);
    if (isNaN(d.getTime()) || d >= now) return false;
    if (RESULT_NOT_REQUIRED.includes(m.status)) return false;
    const noResult = m.home_score === null || m.home_score === undefined || m.away_score === null || m.away_score === undefined;
    return noResult;
  });

  if (overdue.length > 0) {
    items.push({
      id: 'overdue-matches',
      severity: 'warning',
      title: `${new Intl.NumberFormat('ar-EG').format(overdue.length)} مباراة تجاوزت موعدها دون تسجيل نتيجة`,
      description: 'راجع المباريات وحدّث نتائجها لتظهر في التقارير',
      href: '/matches',
      linkText: 'تحديث النتائج',
    });
  }

  return items;
};

export const AttentionItems = ({ items }) => (
  <SectionCard title="يتطلب انتباهك" icon="warning" testId="attention-items">
    {(!items || items.length === 0) ? (
      <EmptyState icon="check" text="لا توجد عناصر تتطلب إجراء حالياً" testId="attention-empty" />
    ) : (
      <ul className="space-y-3">
        {items.map((item) => (
          <li key={item.id} className="flex items-start gap-3 rounded-lg border border-amber-200/70 bg-amber-50/60 px-3 py-2.5" data-testid="attention-item">
            <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700">
              <Icon name="warning" className="w-4 h-4" />
            </span>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-slate-800">{item.title}</div>
              <div className="text-xs text-slate-500">{item.description}</div>
            </div>
            <Link to={item.href} className="shrink-0 text-xs font-semibold text-teal-700 hover:text-teal-800">
              {item.linkText}
            </Link>
          </li>
        ))}
      </ul>
    )}
  </SectionCard>
);

export default AttentionItems;
